// import React, { useMemo } from 'react';
// import WebsiteRenderer from './WebsiteRenderer';

// // Helper function to convert the JSON object to CSS variables
// const generateCssVariables = (config) => {
//     const variables = {};
//     variables['--primary'] = config.primary;
//     variables['--secondary'] = config.secondary;
//      variables['--topbar-bg-color'] = config.topBar.bgColor;
//     variables['--topbar-text-color'] = config.topBar.textColor;
//     variables['--header-bg-color'] = config.header.bgColor;
//     variables['--header-link-color'] = config.header.linkColor;
//      variables['--header-text-color'] = config.header.textColor;
//     variables['--hero-overlay-color'] = config.hero.overlayColor;
//      variables['--secondary-text-color'] = config.hero.subtitleColor;
//      variables['--footer-bg-color'] = config.footer.bgColor;
//     variables['--footer-text-color'] = config.footer.textColor;
//     variables['--footer-link-color'] = config.footer.linkColor;
//     // Add more variables as you expand your StyleBuilder
//     return variables;
// };

// function TemplatePreview({ layout, styleConfig, destinations, heroData, branding, headerMenu, footerData, aboutData, contactData, viewState, onNavigate, mode }) {
//   // useMemo prevents the CSS variables from being recalculated on every render
//   const cssVariables = useMemo(() => generateCssVariables(styleConfig), [styleConfig]);

//   return (
//     // The style attribute applies the CSS variables to this div and all its children
//    <WebsiteRenderer 
//           layout={layout} 
//           destinations={destinations} 
//           heroData={heroData}
//           branding={branding}
//           headerMenu={headerMenu} 
//           footerData={footerData}
//           aboutData={aboutData} 
        
//     contactData={contactData}
//           viewState={viewState} 
//           onNavigate={onNavigate}
//           mode={mode}  
//       />
//   );
// }

// export default TemplatePreview;
import React, { useMemo } from 'react';
import WebsiteRenderer from './WebsiteRenderer';

// 👇 1. ADD THIS HELPER FUNCTION
// This converts the JSON object into actual CSS variables the browser understands
const generateCssVariables = (config) => {
    if (!config) return {};
    const variables = {
        '--font-main': config.body?.fontFamily || "'Inter', sans-serif",
        '--primary': config.primary,
        '--secondary': config.secondary,
        '--topbar-bg-color': config.topBar?.bgColor,
        '--topbar-text-color': config.topBar?.textColor,
        '--header-bg-color': config.header?.bgColor,
        '--header-text-color': config.header?.textColor,
        '--hero-overlay-color': config.hero?.overlayColor,
        '--hero-subtitle-color': config.hero?.subtitleColor,
        '--body-bg': config.body?.bgColor,
        '--body-text': config.body?.textColor,
        // Removed the duplicate --font-family here since --font-main handles it
        '--footer-bg-color': config.footer?.bgColor,
        '--footer-text-color': config.footer?.textColor,
        '--footer-link-color': config.footer?.linkColor
    };
    return variables;
};
function TemplatePreview({ layout, styleConfig, destinations, heroData, branding, headerMenu, footerData, aboutData, contactData, viewState, onNavigate, mode }) {
  
  // 👇 2. USE THE HELPER TO GENERATE THE CSS OBJECT
  // useMemo ensures it only recalculates when you pick a new color
 const cssVariables = useMemo(() => {
     return generateCssVariables(styleConfig);
  },[styleConfig]);
  return (
    // 👇 3. APPLY THE CSS VARIABLES TO THE WRAPPER DIV
    // This makes the colors "cascade" down to all the child components!
     <div style={cssVariables} className="template-wrapper h-100">
       <WebsiteRenderer 
          layout={layout} 
          destinations={destinations} 
          heroData={heroData}
          branding={branding}
          headerMenu={headerMenu} 
          footerData={footerData}
          aboutData={aboutData}
          contactData={contactData}
          viewState={viewState} 
          onNavigate={onNavigate}
          mode={mode}  
      />
    </div>
  );
}

export default TemplatePreview;